document.addEventListener("DOMContentLoaded", () => {
    const bannerVideo = document.getElementById("Video");
    if (bannerVideo) {
        const source = bannerVideo?.dataset.video;

        function appendVideo() {
            const video = document.createElement("video");
            video.autoplay = true;
            video.playsInline = true;
            video.loop = true;
            video.muted = true;
            video.setAttribute("data-object-fit", "cover");
            video.oncanplay = function () {
                this.muted = true;
            };

            const src = document.createElement("source");
            src.src = source;
            src.type = "video/mp4";
            video.appendChild(src);

            bannerVideo.prepend(video);
        }

        function pausePlay() {
            if (!bannerVideo) return;

            const video = bannerVideo.querySelector("video");
            const playPauseButton = document.querySelector(".playpause");
            const playPauseButtonText = document.querySelector(
                "#banner-video-controls-button-text"
            );

            if (video && playPauseButton && playPauseButtonText) {
                playPauseButton.classList.add("__pause");

                playPauseButton.addEventListener("click", () => {
                    if (video.paused) {
                        video.play();
                        playPauseButton.classList.remove("__play");
                        playPauseButton.classList.add("__pause");
                        playPauseButtonText.textContent = "Pause";
                    } else {
                        video.pause();
                        playPauseButton.classList.add("__play");
                        playPauseButton.classList.remove("__pause");
                        playPauseButtonText.textContent = "Play";
                    }
                });
            }
        }

        function screenSizeChecker() {
            const browserWidth = window.innerWidth;

            if (!bannerVideo.querySelector("video")) {
                appendVideo();
                pausePlay();
            }
        }

        screenSizeChecker();

        window.addEventListener("resize", screenSizeChecker);
    }
});
